import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useParams, Link } from 'react-router-dom';
import Globals from '../Globals';
import PopularDestinations from '../components/PopularDestinations';

const resInputCss = {
  width: '100%', padding: '10px 14px', border: '1.5px solid #e2e8f0', borderRadius: '10px',
  fontSize: '0.92rem', color: '#0f172a', outline: 'none', background: 'white',
  boxSizing: 'border-box', transition: 'border-color 0.15s', fontFamily: 'inherit',
};
const onFocusRes = e => { e.target.style.borderColor = '#01225C'; e.target.style.boxShadow = '0 0 0 3px rgba(1,34,92,0.1)'; };
const onBlurRes = e => { e.target.style.borderColor = '#e2e8f0'; e.target.style.boxShadow = 'none'; };

// +/- stepper — exact same visual language as the hotel room picker
const Stepper = ({ value, min, max, onChange }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    <button type="button" onClick={() => value > min && onChange(value - 1)}
      style={{ width: '30px', height: '30px', borderRadius: '50%', border: '1.5px solid ' + (value <= min ? '#e2e8f0' : '#94a3b8'), background: 'white', cursor: value <= min ? 'not-allowed' : 'pointer', fontSize: '1.15rem', lineHeight: 1, color: value <= min ? '#cbd5e1' : '#475569', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.15s', flexShrink: 0, padding: 0 }}>−</button>
    <span style={{ minWidth: '18px', textAlign: 'center', fontWeight: '700', fontSize: '1rem', color: '#0f172a' }}>{value}</span>
    <button type="button" onClick={() => value < max && onChange(value + 1)}
      style={{ width: '30px', height: '30px', borderRadius: '50%', border: '1.5px solid ' + (value >= max ? '#e2e8f0' : '#01225C'), background: value >= max ? '#f8fafc' : '#01225C', cursor: value >= max ? 'not-allowed' : 'pointer', fontSize: '1.15rem', lineHeight: 1, color: value >= max ? '#cbd5e1' : 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.15s', flexShrink: 0, padding: 0 }}>+</button>
  </div>
);

const API = Globals.API;

function VoyageDetails() {
 const { id } = useParams();
 const [event, setEvent] = useState(null);
 const [loading, setLoading] = useState(true);
 const [selectedFlight, setSelectedFlight] = useState(0);
 const [showSlideshow, setShowSlideshow] = useState(false);
 const [slideIndex, setSlideIndex] = useState(0);
 const [rooms, setRooms] = useState([{
 adultes: 2,
 type: 'Double',
 lit3: 0,
 bebe: 0,
 enfant2_6: 0,
 enfant6_12: 0,
 children: []
 }]);
 const [activeDay, setActiveDay] = useState(0);
 const [showResModal, setShowResModal] = useState(false);
 const [resStep, setResStep] = useState(1);
 const [resVoyage, setResVoyage] = useState(null);
 const [resForm, setResForm] = useState({ nom_prenom: '', email: '', adresse: '', ville: '', telephone: '', whatsapp: '', mode_paiement: '', remarque: '' });
 const [resSending, setResSending] = useState(false);
 const [resSent, setResSent] = useState(false);
 const [resFieldErrors, setResFieldErrors] = useState({});
 const [vToast, setVToast] = useState(null);

 // ── Sélecteur de chambres déroulant (identique à l'hôtel) ──
 const [showRoomPicker, setShowRoomPicker] = useState(false);
 const roomPickerRef = useRef(null);
 const triggerBtnRef = useRef(null);
 const [pickerPos, setPickerPos] = useState({ top: 0, left: 0, width: 380 });

 const calcPickerPos = () => {
 if (!triggerBtnRef.current) return;
 const rect = triggerBtnRef.current.getBoundingClientRect();
 const pw = Math.max(rect.width, 380);
 const spaceBelow = window.innerHeight - rect.bottom;
 const spaceAbove = rect.top;
 const openUpward = spaceBelow < 320 && spaceAbove > spaceBelow;
 const left = rect.left + pw > window.innerWidth - 10 ? Math.max(8, rect.right - pw) : rect.left;
 setPickerPos({ top: openUpward ? null : rect.bottom + 6, bottom: openUpward ? window.innerHeight - rect.top + 6 : null, left, width: pw });
 };
 const openRoomPicker = () => { calcPickerPos(); setShowRoomPicker(v => !v); };

 useEffect(() => {
 if (!showRoomPicker) return;
 const handle = (e) => {
 if (roomPickerRef.current && !roomPickerRef.current.contains(e.target) &&
 triggerBtnRef.current && !triggerBtnRef.current.contains(e.target)) setShowRoomPicker(false);
 };
 document.addEventListener('mousedown', handle);
 return () => document.removeEventListener('mousedown', handle);
 }, [showRoomPicker]);

 useEffect(() => {
 if (!showRoomPicker) return;
 const sync = () => {
 if (!triggerBtnRef.current) return;
 const rect = triggerBtnRef.current.getBoundingClientRect();
 if (rect.top < -10 || rect.bottom > window.innerHeight + 10) { setShowRoomPicker(false); return; }
 const pw = Math.max(rect.width, 380);
 const spaceBelow = window.innerHeight - rect.bottom;
 const spaceAbove = rect.top;
 const openUpward = spaceBelow < 320 && spaceAbove > spaceBelow;
 const left = rect.left + pw > window.innerWidth - 10 ? Math.max(8, rect.right - pw) : rect.left;
 setPickerPos({ top: openUpward ? null : rect.bottom + 6, bottom: openUpward ? window.innerHeight - rect.top + 6 : null, left, width: pw });
 };
 window.addEventListener('scroll', sync, { passive: true, capture: true });
 window.addEventListener('resize', sync, { passive: true });
 return () => {
 window.removeEventListener('scroll', sync, { capture: true });
 window.removeEventListener('resize', sync);
 };
 }, [showRoomPicker]);

 useEffect(() => {
 window.scrollTo({ top: 0, behavior: 'instant' });
 fetchEventDetails();
 }, [id]);

 const fetchEventDetails = async () => {
 try {
 const response = await fetch(`${API}/events/${id}`);
 const data = await response.json();
 if (data.success) {
 setEvent(data.data);
 } else {
 setEvent(null);
 }
 setLoading(false);
 } catch (error) {
 console.error('Error fetching event details:', error);
 setLoading(false);
 }
 };

 const showVToast = (msg, type = 'error') => {
   setVToast({ msg, type });
   setTimeout(() => setVToast(null), 4000);
 };

 const openResModal = () => {
   const flight = event?.departureDates?.[selectedFlight] || event?.departureDates?.[0];
   const nights = flight?.nights || flight?.duration || null;
   const roomsSummary = rooms.map((r, i) => {
     const parts = [`Chambre ${i + 1}: ${r.adultes} adulte${r.adultes > 1 ? 's' : ''} (${r.type})`];
     if (r.lit3 > 0) parts.push(`3ème lit ×${r.lit3}`);
     if (r.enfant6_12 > 0) parts.push(`Enfant 6-12 ×${r.enfant6_12}`);
     if (r.enfant2_6 > 0) parts.push(`Enfant 2-6 ×${r.enfant2_6}`);
     if (r.bebe > 0) parts.push(`Bébé ×${r.bebe}`);
     return parts.join(' · ');
   }).join('\n');
   setResVoyage({
     voyage_name: event?.name || event?.title || '',
     voyage_destination: event?.destination || event?.country || '',
     voyage_departure_date: flight?.departureDate || flight?.date || '',
     voyage_departure_city: flight?.departureCity || flight?.from || '',
     voyage_return_date: flight?.returnDate || '',
     voyage_nights: nights,
     voyage_rooms: roomsSummary,
     voyage_total_price: getTotalPrice(),
   });
   setResStep(1);
   setResForm({ nom_prenom: '', email: '', adresse: '', ville: '', telephone: '', whatsapp: '', mode_paiement: '', remarque: '' });
   setResSent(false);
   setResFieldErrors({});
   setShowResModal(true);
   document.body.style.overflow = 'hidden';
 };

 const closeResModal = () => {
   setShowResModal(false);
   document.body.style.overflow = 'unset';
 };

 const submitReservation = async () => {
   const errors = {};
   if (!resForm.nom_prenom.trim()) errors.nom_prenom = 'Ce champ est obligatoire';
   if (!resForm.email.trim()) errors.email = 'Ce champ est obligatoire';
   else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(resForm.email.trim())) errors.email = 'Adresse email invalide';
   if (!resForm.telephone.trim()) errors.telephone = 'Ce champ est obligatoire';
   if (Object.keys(errors).length > 0) {
     setResFieldErrors(errors);
     showVToast('Veuillez corriger les champs en rouge.', 'warning');
     return;
   }
   setResFieldErrors({});
   setResSending(true);
   try {
     const res = await fetch(`${API}/reservations/voyage`, {
       method: 'POST',
       headers: { 'Content-Type': 'application/json' },
       body: JSON.stringify({ ...resForm, ...resVoyage }),
     });
     const data = await res.json();
     if (data.success) {
       setResSent(true);
       setResStep(3);
     } else {
       showVToast(data.message || 'Erreur lors de l\'envoi.', 'error');
     }
   } catch {
     showVToast('Erreur réseau. Veuillez réessayer.', 'error');
   } finally {
     setResSending(false);
   }
 };

 const getTotalPrice = () => {
 if (!event || !event.departureDates || event.departureDates.length === 0) return 0;
 const flight = event.departureDates[selectedFlight] || event.departureDates[0];
 const b2c = flight?.pricing?.b2c || {};
 
 // Extrait les prix du backend (avec fallbacks)
 const basePrice = parseFloat(b2c.price) || parseFloat(flight?.pricing?.price) || 0;
 const demiDouble = parseFloat(b2c.tarifdemidouble) || basePrice;
 const supplSingle = parseFloat(b2c.spplementsingle) || 0;
 const lit3 = parseFloat(b2c.tarif3eme) || 0;
 const bebePrice = parseFloat(b2c.bebe) || 0;
 const enf2_6Price = parseFloat(b2c.enf2_6) || 0;
 const enf6_12Price = parseFloat(b2c.enf6_12) || 0;

 let total = 0;
 rooms.forEach(room => {
 const adultes = parseInt(room.adultes) || 0;
 
 let roomAdultPrice = 0;
 if (room.type === 'Single') {
 roomAdultPrice = adultes * (demiDouble + supplSingle);
 } else {
 roomAdultPrice = adultes * demiDouble;
 }
 
 total += roomAdultPrice;
 total += (parseInt(room.lit3) || 0) * lit3;
 total += (parseInt(room.bebe) || 0) * bebePrice;
 total += (parseInt(room.enfant2_6) || 0) * enf2_6Price;
 total += (parseInt(room.enfant6_12) || 0) * enf6_12Price;
 });
 return isNaN(total) ? 0 : total;
 };

 const parseProgramDays = (ev) => {
 if (ev?.programDetails && ev.programDetails.length > 0) {
 return ev.programDetails.map((d, i) => ({
 title: d.title || `Jour ${i + 1}`,
 subtitle: d.subtitle || d.title || `Jour ${i + 1}`,
 description: d.description || '',
 image: d.image || ev.image,
 meals: d.meals && d.meals.length > 0 ? d.meals : ['Petit Déjeuner', 'Déjeuner', 'Dîner']
 }));
 }
 if (Array.isArray(ev?.program) && ev.program.length > 0 && typeof ev.program[0] === 'object') {
 return ev.program.map((d, i) => ({
 title: d.title || `Jour ${i + 1}`,
 subtitle: d.subtitle || d.title || `Jour ${i + 1}`,
 description: d.description || '',
 image: d.image || ev.image,
 meals: d.meals || ['Petit Déjeuner', 'Déjeuner', 'Dîner'],
 }));
 }
 if (typeof ev?.program === 'string' && ev.program.trim()) {
 return ev.program.split('\n').filter(l => l.trim()).map((line, i) => ({
 title: `Jour ${i + 1}`,
 subtitle: `Jour ${i + 1}`,
 description: line.replace(/^Jour\s*\d+\s*:\s*/i, '').trim(),
 image: ev.image,
 meals: i % 3 === 0 ? ['Petit Déjeuner'] : i % 3 === 1 ? ['Petit Déjeuner', 'Déjeuner'] : ['Petit Déjeuner', 'Déjeuner', 'Dîner'],
 }));
 }
 return [
 { title: 'Jour 1', subtitle: 'Arrivée & Installation', description:"Accueil à l'aéroport et transfert vers l'hôtel. Installation dans vos chambres et présentation du programme. Dîner de bienvenue au restaurant de l'hôtel.", image: ev?.image, meals: ['Dîner'] },
 { title: 'Jour 2', subtitle: 'Découverte de la ville', description:"Visite guidée du centre historique, des monuments emblématiques et des marchés locaux. Déjeuner dans un restaurant traditionnel. Après-midi libre.", image: ev?.image, meals: ['Petit Déjeuner', 'Déjeuner'] },
 { title: 'Jour 3', subtitle: 'Excursion en nature', description:"Départ matinal pour une excursion dans les environs. Randonnée panoramique avec vue imprenable sur le paysage. Pique-nique en plein air.", image: ev?.image, meals: ['Petit Déjeuner', 'Déjeuner'] },
 { title: 'Jour 4', subtitle: 'Culture & Gastronomie', description:"Visite d'un musée national et d'une galerie d'art contemporain. Cours de cuisine locale avec un chef réputé. Dégustation des spécialités régionales.", image: ev?.image, meals: ['Petit Déjeuner', 'Dîner'] },
 { title: 'Jour 5', subtitle: 'Journée libre', description:"Journée libre à votre disposition. Possibilité d'excursions optionnelles (supplément). Shopping dans les souks et bazars.", image: ev?.image, meals: ['Petit Déjeuner', 'Dîner'] },
 { title: 'Jour 6', subtitle: 'Retour', description:"Petit déjeuner à l'hôtel. Transfert vers l'aéroport selon les horaires de vol. Assistance lors de l'enregistrement et vol retour.", image: ev?.image, meals: ['Petit Déjeuner'] },
 ];
 };

 if (loading) {
 return (
 <div className="text-center py-5" style={{ minHeight: '60vh' }}>
 <div className="spinner-border" style={{ color: '#01225C' }} role="status"></div>
 </div>
 );
 }

 if (!event) {
 return <div className="text-center py-5">Voyage non trouvé.</div>;
 }

 const currentFlight = event.departureDates?.[selectedFlight] || event.departureDates?.[0];
 const b2c = currentFlight?.pricing?.b2c || {};
 
 const hasSingle = b2c.spplementsingle != null && b2c.spplementsingle !== '';
 const hasLit3 = b2c.tarif3eme != null && b2c.tarif3eme !== '';
 const hasBebe = b2c.bebe != null && b2c.bebe !== '';
 const hasEnf2_6 = b2c.enf2_6 != null && b2c.enf2_6 !== '';
 const hasEnf6_12 = b2c.enf6_12 != null && b2c.enf6_12 !== '';

 // Tranches d'âge enfant disponibles (exactement la logique existante, juste affichées en liste)
 const childOptions = [
   ...(hasBebe ? [{ key: 'bebe', label: 'Bébé (-2 ans)' }] : []),
   ...(hasEnf2_6 ? [{ key: 'enfant2_6', label: 'Enfant 2-6 ans' }] : []),
   ...(hasEnf6_12 ? [{ key: 'enfant6_12', label: 'Enfant 6-12 ans' }] : []),
 ];
 const hasChildren = childOptions.length > 0;
 const defaultChild = childOptions[0]?.key ?? null;
 // Compteurs par tranche dérivés des choix (alimente getTotalPrice & l'email sans rien changer)
 const bracketCounts = (brackets = []) => ({
   bebe: brackets.filter(b => b === 'bebe').length,
   enfant2_6: brackets.filter(b => b === 'enfant2_6').length,
   enfant6_12: brackets.filter(b => b === 'enfant6_12').length,
 });
 // Met à jour le nombre d'enfants d'une chambre + recalcule les compteurs de tranche
 const setRoomChildren = (idx, brackets) => {
   const r = [...rooms];
   r[idx] = { ...r[idx], children: brackets, ...bracketCounts(brackets) };
   setRooms(r);
 };

const programDays = parseProgramDays(event);

const activeProgram = programDays[activeDay];
 // Taille du cercle
 const CIRCLE = 20; // px (width/height du cercle dans le code original)
 const CIRCLE_LEFT = 9; // left de la ligne (axe du cercle)

 const allImages = Array.from(new Set([
 event.gallery?.[0] || event.image ||"assets/img/dest1.jpg",
 event.gallery?.[1] || event.image ||"assets/img/dest2.jpg",
 event.gallery?.[2] || event.image ||"assets/img/dest3.jpg",
 ...(event.gallery || [])
 ].filter(Boolean)));

 const handlePrevSlide = () => setSlideIndex((prev) => (prev === 0 ? allImages.length - 1 : prev - 1));
 const handleNextSlide = () => setSlideIndex((prev) => (prev === allImages.length - 1 ? 0 : prev + 1));

 return (
 <>
 {showSlideshow && (
 <div 
 className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center" 
 style={{ zIndex: 9999, backgroundColor: 'rgba(0, 0, 0, 0.95)', backdropFilter: 'blur(10px)' }}
 >
 <button 
 className="btn position-absolute top-0 end-0 m-3 text-white" 
 onClick={() => setShowSlideshow(false)}
 style={{ fontSize: '1.5rem', zIndex: 10000, background: 'rgba(255,255,255,0.1)', borderRadius: '50%', width: '50px', height: '50px' }}
 >
 <i className="fa fa-times"></i>
 </button>
 
 <div className="position-relative w-100 d-flex justify-content-center align-items-center" style={{ flex: 1, maxHeight: '75vh', marginTop: '5vh' }}>
 <button 
 className="btn position-absolute start-0 ms-2 ms-md-4 text-white" 
 onClick={handlePrevSlide}
 style={{ fontSize: '1.5rem', backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: '50%', width: '50px', height: '50px', zIndex: 10 }}
 >
 <i className="fa fa-chevron-left"></i>
 </button>
 
 <img 
 src={allImages[slideIndex]} 
 alt={`Slide ${slideIndex + 1}`} 
 className="img-fluid rounded-3" 
 style={{ maxHeight: '100%', maxWidth: '85%', objectFit: 'contain', boxShadow: '0 10px 40px rgba(0,0,0,0.5)', transition: 'opacity 0.3s ease-in-out' }} 
 />
 
 <button 
 className="btn position-absolute end-0 me-2 me-md-4 text-white" 
 onClick={handleNextSlide}
 style={{ fontSize: '1.5rem', backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: '50%', width: '50px', height: '50px', zIndex: 10 }}
 >
 <i className="fa fa-chevron-right"></i>
 </button>
 </div>
 
 <div className="w-100 d-flex justify-content-center align-items-center p-3 gap-2 overflow-auto hide-scrollbar" style={{ height: '15vh', marginBottom: '2vh' }}>
 {allImages.map((img, idx) => (
 <div 
 key={idx} 
 onClick={() => setSlideIndex(idx)}
 style={{ height: '100%', minWidth: '100px', cursor: 'pointer', borderRadius: '8px', overflow: 'hidden', border: idx === slideIndex ? '3px solid #FFBC1E' : '2px solid transparent', transition: 'all 0.2s', opacity: idx === slideIndex ? 1 : 0.4 }}
 >
 <img 
 src={img}
 alt={`Thumb ${idx}`}
 className="w-100 h-100"
 style={{ objectFit: 'cover' }}
 />
 </div>
 ))}
 </div>
 </div>
 )}

 <div className="container py-4">

 {/* ══ BREADCRUMB ══ */}
 <nav aria-label="breadcrumb" className="mb-4">
 <ol className="breadcrumb" style={{ fontSize: '13px', fontWeight: '500' }}>
 <li className="breadcrumb-item"><Link to="/" style={{ color: '#01225D', textDecoration: 'none' }}>Accueil</Link></li>
 <li className="breadcrumb-item"><Link to="/voyage" style={{ color: '#01225D', textDecoration: 'none' }}>Voyages</Link></li>
 <li className="breadcrumb-item"><Link to="/voyage" style={{ color: '#01225D', textDecoration: 'none' }}>Voyages organisés</Link></li>
 <li className="breadcrumb-item active" aria-current="page" style={{ color: '#6c757d' }}>{event.title}</li>
 </ol>
 </nav>

 {/* ══ HERO + SUMMARY ══ */}
 <div className="row g-4 mb-4">
 <div className="col-lg-8">
 <div className="row g-3 h-100">
 <div className="col-md-8">
 <img
 src={event.gallery?.[0] || event.image ||"assets/img/dest1.jpg"}
 alt={event.destination}
 className="w-100 h-100 rounded-3 object-fit-cover"
 style={{ minHeight: '400px' }}
 />
 </div>
 <div className="col-md-4 d-flex flex-column gap-3">
 <img
 src={event.gallery?.[1] || event.image ||"assets/img/dest2.jpg"}
 alt={event.destination}
 className="w-100 rounded-3 object-fit-cover"
 style={{ height: 'calc(50% - 0.5rem)' }}
 />
 <div className="position-relative w-100 rounded-3 overflow-hidden" style={{ height: 'calc(50% - 0.5rem)' }}>
 <img
 src={event.gallery?.[2] || event.image ||"assets/img/dest3.jpg"}
 alt={event.destination}
 className="w-100 h-100 object-fit-cover"
 />
 <div className="position-absolute bottom-0 end-0 m-3">
 <button 
 className="btn bg-white fw-bold px-4 py-2" 
 onClick={() => setShowSlideshow(true)}
 style={{ fontSize: '14px', color: '#01225C', borderRadius: '10px', boxShadow: '0 4px 15px rgba(0,0,0,0.15)', transition: 'transform 0.2s', zIndex: 5 }}
 onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
 onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
 >
 <i className="fa fa-camera me-2" style={{ color: '#FFBC1E' }}></i> Voir diaporama
 </button>
 </div>
 </div>
 </div>
 </div>
 </div>

 <div className="col-lg-4">
 <div className="card h-100 border-0 flex-column" style={{ borderRadius: '12px', boxShadow: '0 0 20px rgba(0,0,0,0.05)' }}>
 <div className="card-body p-4 d-flex flex-column">
 <div className="d-flex justify-content-end mb-2">
 <span className="badge rounded-3" style={{ backgroundColor: '#FFBC1E', color: 'white', fontSize: '12px', padding: '6px 12px' }}>
 {event.departureDates?.[0]?.availableSeats || 20} places disponibles
 </span>
 </div>
 <h1 className="fw-bold my-3" style={{ color: '#01225C', fontFamily:"'Playfair Display', serif", fontSize: '32px' }}>
 {event.title}
 </h1>
 <p className="fw-bold mb-4" style={{ color: '#01225C', fontSize: '15px' }}>{event.destination}</p>
 <p className="mb-4" style={{ color: '#01225C', fontSize: '13px', lineHeight: '1.6' }}>{event.description}</p>
 <p className="fw-bold mb-2" style={{ color: '#01225C', fontSize: '14px' }}>
 {event.departureDates?.length || 2} Départs disponibles
 </p>
 <div className="mt-auto pt-4 border-top">
 <p className="fw-bold mb-2" style={{ color: '#01225C', fontSize: '14px' }}>Votre Voyage Inclut</p>
 <div className="d-flex gap-3" style={{ color: '#FFBC1E', fontSize: '1.2rem' }}>
 <i className="fa fa-plane"></i>
 <i className="fa fa-suitcase"></i>
 <i className="fa fa-car"></i>
 <i className="fa fa-map-marked-alt"></i>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>

 {/* ══ PRICING CALCULATOR ══ */}
 <div className="card border-0 mb-4" style={{ borderRadius: '12px', boxShadow: '0 0 20px rgba(0,0,0,0.05)' }}>
 <div className="card-body p-4">
 {/* Détail des tarifs disponibles */}
 {(() => {
 const priceRows = [
 { show: true, icon: 'fa fa-user', label: 'Prix standard / adulte', val: b2c.price || currentFlight?.pricing?.price },
 { show: b2c.tarifdemidouble != null && b2c.tarifdemidouble !== '', icon: 'fa fa-user-friends', label: 'Tarif demi-double', val: b2c.tarifdemidouble },
 { show: hasSingle, icon: 'fa fa-bed', label: 'Supplément single', val: b2c.spplementsingle },
 { show: hasLit3, icon: 'fa fa-bed', label: '3ᵉ lit', val: b2c.tarif3eme },
 { show: hasEnf6_12, icon: 'fa fa-child', label: 'Enfant 6-12 ans', val: b2c.enf6_12 },
 { show: hasEnf2_6, icon: 'fa fa-child', label: 'Enfant 2-6 ans', val: b2c.enf2_6 },
 { show: hasBebe, icon: 'fa fa-baby', label: 'Bébé (-2 ans)', val: b2c.bebe },
 ].filter(r => r.show && r.val != null && r.val !== '');
 return (
 <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center', marginBottom: '8px' }}>
 {priceRows.map((r, i) => (
 <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 14px', background: '#f8faff', border: '1px solid #e3ebf7', borderRadius: '12px' }}>
 <span style={{ width: '30px', height: '30px', borderRadius: '9px', background: '#eef2fb', color: '#01225C', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
 <i className={r.icon} style={{ fontSize: '0.8rem' }}></i>
 </span>
 <div style={{ lineHeight: 1.2 }}>
 <div style={{ fontSize: '0.68rem', color: '#94a3b8', fontWeight: '600' }}>{r.label}</div>
 <div style={{ fontSize: '0.95rem', fontWeight: '800', color: '#01225C' }}>{Number(r.val).toLocaleString('fr-FR')} <span style={{ fontSize: '0.7rem', fontWeight: '600' }}>TND</span></div>
 </div>
 </div>
 ))}
 </div>
 );
 })()}

 <h4 className="fw-bold mb-4" style={{ color: '#01225C', fontSize: '20px' }}>Calculer votre prix</h4>

 {/* Vols */}
 <div className="mb-4">
 <p className="text-muted mb-3" style={{ fontSize: '14px', fontWeight: '500' }}>Choisir votre vol</p>
 <div className="d-flex flex-wrap gap-3">
 {(event.departureDates || []).map((date, idx) => (
 <div
 key={idx}
 onClick={() => setSelectedFlight(idx)}
 style={{
 backgroundColor: selectedFlight === idx ? '#01225C' : '#FBFDFF',
 color: selectedFlight === idx ? 'white' : '#01225C',
 borderColor: selectedFlight === idx ? '#01225C' : '#e9ecef',
 border: `1px solid ${selectedFlight === idx ? '#01225C' : '#e9ecef'}`,
 borderRadius: '10px',
 padding: '12px 16px',
 minWidth: '200px',
 cursor: 'pointer',
 transition: 'all 0.2s ease'
 }}
 >
 <div className="d-flex align-items-center mb-2" style={{ fontSize: '13px' }}>
 <i className="fa fa-plane-departure me-2"></i>
 <span>Aller : {date.departureDate ? new Date(date.departureDate).toLocaleDateString('fr-FR') : '29/03/2026'}</span>
 </div>
 <div className="d-flex align-items-center" style={{ fontSize: '13px' }}>
 <i className="fa fa-plane-arrival me-2"></i>
 <span>Retour : {date.returnDate ? new Date(date.returnDate).toLocaleDateString('fr-FR') : '29/03/2026'}</span>
 </div>
 </div>
 ))}
 </div>
 </div>

 {/* Chambres */}
 <div className="row mt-4">
 <div className="col-12">
        {/* Selecteur de chambres deroulant - identique a l'hotel */}
        <label className="form-label fw-semibold mb-2" style={{ color: '#01225C', fontSize: '14px' }}>
          <i className="fa fa-users me-2"></i>Chambres et Occupation
        </label>
        {(() => {
          const totalAdultes = rooms.reduce((s, r) => s + (parseInt(r.adultes) || 0), 0);
          const totalEnfants = rooms.reduce((s, r) => s + ((r.children || []).length), 0);
          return (
            <button ref={triggerBtnRef} type="button" onClick={openRoomPicker}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', maxWidth: '440px', padding: '10px 16px', background: 'white', border: '1px solid ' + (showRoomPicker ? '#01225C' : '#dee2e6'), borderRadius: '10px', fontSize: '0.92rem', color: '#212529', cursor: 'pointer', height: '46px', boxShadow: showRoomPicker ? '0 0 0 3px rgba(1,34,92,0.1)' : 'none', transition: 'all 0.15s' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <i className="fa fa-bed" style={{ color: '#01225C' }}></i>
                <span style={{ fontWeight: '500' }}>
                  {rooms.length} chambre{rooms.length > 1 ? 's' : ''} &nbsp;&middot;&nbsp; {totalAdultes} adulte{totalAdultes > 1 ? 's' : ''}
                  {totalEnfants > 0 ? ' \u00b7 ' + totalEnfants + ' enfant' + (totalEnfants > 1 ? 's' : '') : ''}
                </span>
              </span>
              <i className={'fa fa-chevron-' + (showRoomPicker ? 'up' : 'down')} style={{ color: '#94a3b8', fontSize: '0.75rem' }}></i>
            </button>
          );
        })()}

        {showRoomPicker && createPortal(
          <>
            <style>{`@keyframes pickerIn { from { opacity:0; transform:translateY(-6px) scale(0.98); } to { opacity:1; transform:translateY(0) scale(1); } } .room-picker-panel { animation: pickerIn 0.18s cubic-bezier(0.22,1,0.36,1) both; }`}</style>
            <div ref={roomPickerRef} className="room-picker-panel" style={{ position: 'fixed', top: pickerPos.top ?? 'auto', bottom: pickerPos.bottom ?? 'auto', left: pickerPos.left, width: pickerPos.width, background: 'white', borderRadius: '16px', boxShadow: '0 20px 60px rgba(1,34,92,0.18), 0 4px 16px rgba(0,0,0,0.08)', border: '1px solid rgba(1,34,92,0.12)', zIndex: 99999, overflow: 'hidden' }}>
              <div style={{ padding: '14px 20px 10px', borderBottom: '1px solid #f1f5f9' }}>
                <span style={{ fontSize: '0.68rem', fontWeight: '800', color: '#94a3b8', letterSpacing: '0.1em', textTransform: 'uppercase' }}>Chambres et Occupation</span>
              </div>

              <div style={{ maxHeight: '52vh', overflowY: 'auto', padding: '8px 0' }}>
                {rooms.map((room, rIdx) => {
                  const upd = (field, val) => { const r = [...rooms]; r[rIdx] = { ...r[rIdx], [field]: val }; setRooms(r); };
                  const typeOptions = ['Double', ...(hasSingle ? ['Single'] : []), 'Triple'];
                  const childList = room.children || [];
                  const setChildCount = (n) => { const next = [...childList]; while (next.length < n) next.push(defaultChild); next.length = n; setRoomChildren(rIdx, next); };
                  const setChildBracket = (cIdx, key) => { const next = [...childList]; next[cIdx] = key; setRoomChildren(rIdx, next); };
                  return (
                    <div key={rIdx} style={{ padding: '14px 20px', borderBottom: rIdx < rooms.length - 1 ? '1px solid #f1f5f9' : 'none' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '14px' }}>
                        <span style={{ fontWeight: '700', color: '#01225C', fontSize: '0.9rem' }}>Chambre {rIdx + 1}</span>
                        {rooms.length > 1 && (
                          <button type="button" onClick={() => setRooms(rooms.filter((_, i) => i !== rIdx))}
                            style={{ background: '#fef2f2', border: 'none', borderRadius: '8px', cursor: 'pointer', color: '#ef4444', padding: '4px 8px', fontSize: '0.75rem', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <i className="fa fa-trash" style={{ fontSize: '0.7rem' }}></i> Supprimer
                          </button>
                        )}
                      </div>

                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                        <div style={{ fontWeight: '600', fontSize: '0.88rem', color: '#0f172a' }}>Type de chambre</div>
                        <select value={room.type} onChange={e => upd('type', e.target.value)}
                          style={{ padding: '7px 12px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '0.85rem', color: '#0f172a', background: 'white', cursor: 'pointer', fontWeight: '600' }}>
                          {typeOptions.map(t => <option key={t} value={t}>{t}</option>)}
                        </select>
                      </div>

                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                        <div>
                          <div style={{ fontWeight: '600', fontSize: '0.88rem', color: '#0f172a' }}>Adulte(s)</div>
                          <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: '1px' }}>12 ans et +</div>
                        </div>
                        <Stepper value={room.adultes} min={1} max={4} onChange={v => upd('adultes', v)} />
                      </div>

                      {hasLit3 && (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                          <div>
                            <div style={{ fontWeight: '600', fontSize: '0.88rem', color: '#0f172a' }}>3e lit</div>
                            <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: '1px' }}>lit supplementaire</div>
                          </div>
                          <Stepper value={room.lit3} min={0} max={3} onChange={v => upd('lit3', v)} />
                        </div>
                      )}

                      {hasChildren && (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                          <div>
                            <div style={{ fontWeight: '600', fontSize: '0.88rem', color: '#0f172a' }}>Enfant(s)</div>
                            <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginTop: '1px' }}>Moins de 12 ans</div>
                          </div>
                          <Stepper value={childList.length} min={0} max={4} onChange={setChildCount} />
                        </div>
                      )}

                      {hasChildren && childList.length > 0 && (
                        <div style={{ marginTop: '12px', padding: '12px', background: '#f8fafc', borderRadius: '10px' }}>
                          <div style={{ fontSize: '0.68rem', fontWeight: '700', color: '#94a3b8', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '10px' }}>Age de chaque enfant</div>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                            {childList.map((key, cIdx) => (
                              <div key={cIdx} style={{ textAlign: 'center' }}>
                                <div style={{ fontSize: '0.68rem', color: '#64748b', marginBottom: '5px', fontWeight: '500' }}>Enfant {cIdx + 1}</div>
                                <select value={key} onChange={e => setChildBracket(cIdx, e.target.value)}
                                  style={{ padding: '5px 8px', borderRadius: '8px', border: '1px solid #e2e8f0', fontSize: '0.82rem', color: '#0f172a', background: 'white', cursor: 'pointer', fontWeight: '600' }}>
                                  {childOptions.map(o => <option key={o.key} value={o.key}>{o.label}</option>)}
                                </select>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>

              <div style={{ padding: '12px 20px', borderTop: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fafbfc' }}>
                <button type="button" onClick={() => rooms.length < 4 && setRooms([...rooms, { adultes: 2, type: 'Double', lit3: 0, bebe: 0, enfant2_6: 0, enfant6_12: 0, children: [] }])} disabled={rooms.length >= 4}
                  style={{ background: 'none', border: '1.5px solid #01225C', color: '#01225C', borderRadius: '8px', padding: '7px 14px', fontSize: '0.82rem', fontWeight: '700', cursor: rooms.length >= 4 ? 'not-allowed' : 'pointer', opacity: rooms.length >= 4 ? 0.35 : 1, display: 'flex', alignItems: 'center', gap: '6px' }}>
                  <i className="fa fa-plus" style={{ fontSize: '0.75rem' }}></i> Ajouter chambre
                </button>
                <button type="button" onClick={() => setShowRoomPicker(false)}
                  style={{ background: 'linear-gradient(135deg, #01225C 0%, #1e3a5f 100%)', border: 'none', color: 'white', borderRadius: '8px', padding: '7px 20px', fontSize: '0.82rem', fontWeight: '700', cursor: 'pointer', boxShadow: '0 2px 8px rgba(1,34,92,0.25)' }}>
                  Valider
                </button>
              </div>
            </div>
          </>,
          document.body
        )}
 </div>

 <div className="col-12 mt-4">
 <div className="d-flex flex-column align-items-end justify-content-end w-100 border-top pt-3">
 <div className="d-flex justify-content-start align-items-center gap-4 mb-3">
 <span className="fw-bold" style={{ color: '#01225C', fontSize: '20px' }}>Total à payer</span>
 <div className="border bg-white fw-bold d-flex justify-content-center align-items-center"
 style={{ borderRadius: '6px', color: '#01225C', borderColor: '#e9ecef', fontSize: '16px', padding: '10px 30px', minWidth: '120px' }}>
 {getTotalPrice().toLocaleString()} TND
 </div>
 </div>
 <div className="d-flex justify-content-end w-100 mt-2">
 <button onClick={openResModal} className="btn fw-bold px-4 py-2" style={{ backgroundColor: '#01225C', color: 'white', borderRadius: '6px', fontSize: '14px', width: '200px' }}>
 <i className="fa fa-calendar-check me-2"></i>Réserver
 </button>
 </div>
 </div>
 </div>
 </div>
 </div>
 </div>

 {/* ══ DESCRIPTIF ══ */}
 <div className="mb-5">
 <h2 className="fw-bold mb-4" style={{ color: '#00338C', fontSize: '28px' }}>Descriptif de votre voyage</h2>
 <p style={{ color: '#01225C', lineHeight: '1.8', fontSize: '15px' }}>{event.description}</p>
 </div>

 </div>

 {/* ══ PROGRAMME TIMELINE ══ */}
 <div className="container-fluid py-5" style={{ backgroundColor: '#F4F7FC' }}>
 <div className="container">
 <h2 className="fw-bold mb-5" style={{ color: '#01225D', fontSize: '28px' }}>Votre Programme</h2>

 <div className="row g-5">

 {/* ── Timeline gauche ── */}
 <div className="col-lg-5">
 <div className="position-relative" style={{ paddingLeft: '40px' }}>

 {programDays.map((day, idx) => (
 <div
 key={idx}
 className="position-relative"
 style={{ marginBottom: idx < programDays.length - 1 ? '0' : '0' }}
 onClick={() => setActiveDay(idx)}
 >
 {/* ── Segment de ligne entre ce nœud et le suivant ── */}
 {idx < programDays.length - 1 && (
 <div style={{
 position: 'absolute',
 left: `${-40 + CIRCLE / 2 - 1}px`, 
 top: `${CIRCLE + 2}px`, 
 width: '1px',
 bottom: '0',
 backgroundColor: '#FFBC1E',
 zIndex: 0
 }} />
 )}

 {/* ── Cercle ── */}
 <div
 className="position-absolute rounded-circle"
 style={{
 width: `${CIRCLE}px`,
 height: `${CIRCLE}px`,
 left: '-30px',
 top: '2px',
 backgroundColor: 'white',
 border: `#FFBC1E solid ${idx === activeDay ? '6px' : '1.5px'}`,
 transform: 'translateX(-50%)',
 cursor: 'pointer',
 zIndex: 1,
 transition: 'border-width 0.2s ease',
 boxSizing: 'border-box'
 }}
 />

 {/* ── Texte + séparateur ── */}
 <div className="pb-4" style={{ borderBottom: idx < programDays.length - 1 ? '1px solid rgba(0,0,0,0.05)' : 'none' }}>
 <p
 className="mb-1"
 style={{
 fontSize: '15px',
 color: idx === activeDay ? '#00338C' : '#495057',
 cursor: 'pointer'
 }}
 >
 <span className="fw-bold" style={{ color: idx === activeDay ? '#01225D' : '#495057' }}>
 {day.title} :
 </span>{' '}
 {day.description}
 </p>
 </div>
 </div>
 ))}

 </div>
 </div>

 {/* ── Détail du jour actif (droite) ── */}
 <div className="col-lg-7">
 <div style={{ position: 'sticky', top: '100px' }}>
 <img
 key={activeDay}
 src={activeProgram?.image || event.image || 'assets/img/dest1.jpg'}
 alt={activeProgram?.title || 'Programme'}
 className="img-fluid rounded-3 mb-4 shadow-sm"
 style={{ width: '100%', height: '350px', objectFit: 'cover' }}
 />
 <h4 className="fw-bold mb-3" style={{ color: '#01225D', fontSize: '20px', fontFamily: 'Inter, sans-serif' }}>
 {activeProgram?.subtitle || activeProgram?.title}
 </h4>
 <p className="mb-4" style={{ fontSize: '14px', lineHeight: '1.8', color: '#01225C', fontFamily: 'Inter, sans-serif' }}>
 {activeProgram?.description}
 </p>
 {activeProgram?.meals?.length > 0 && (
 <div className="d-flex gap-4 flex-wrap" style={{ color: '#00338C', fontSize: '13px', fontWeight: '500', fontFamily: 'Inter, sans-serif' }}>
 {activeProgram.meals.map((meal, i) => (
 <div key={i}><i className="fa fa-check me-2"></i>{meal}</div>
 ))}
 </div>
 )}
 </div>
 </div>

 </div>
 </div>
 </div>

 {/* ══ INCLUSIONS / EXCLUSIONS ══ */}
 <div className="container-fluid" style={{ display: 'flex', padding: 0 }}>
 <div className="col-6 py-5 px-5" style={{ backgroundColor: '#01153E' }}>
 <div className="ps-lg-5 ms-lg-5">
 <h3 className="fw-bold text-white mb-4" style={{ fontSize: '24px' }}>Votre voyage inclut</h3>
 <ul className="list-unstyled text-white" style={{ fontSize: '15px' }}>
 {event.includedServices?.length > 0
 ? event.includedServices.map((s, i) => (
 <li key={i} className="mb-3"><i className="fa fa-check me-3"></i>{s}</li>
 ))
 : <>
 <li className="mb-3"><i className="fa fa-check me-3"></i> Petit Déjeuner</li>
 <li className="mb-3"><i className="fa fa-check me-3"></i> Billet d'avion A/R</li>
 <li className="mb-3"><i className="fa fa-check me-3"></i> Transfert</li>
 </>
 }
 </ul>
 </div>
 </div>
 <div className="col-6 py-5 px-5" style={{ backgroundColor: '#01225D' }}>
 <div className="pe-lg-5 me-lg-5">
 <h3 className="fw-bold text-white mb-4" style={{ fontSize: '24px' }}>Votre voyage n'inclut pas</h3>
 <ul className="list-unstyled text-white" style={{ fontSize: '15px' }}>
 {event.excludedServices?.length > 0
 ? event.excludedServices.map((s, i) => (
 <li key={i} className="mb-3"><i className="fa fa-times me-3"></i>{s}</li>
 ))
 : <>
 <li className="mb-3"><i className="fa fa-times me-3"></i> Frais de visa</li>
 <li className="mb-3"><i className="fa fa-times me-3"></i> Dépenses personnelles</li>
 <li className="mb-3"><i className="fa fa-times me-3"></i> Assurances voyages</li>
 </>
 }
 </ul>
 </div>
 </div>
 </div>

 {/* ══ DESTINATIONS POPULAIRES ══ */}
 <PopularDestinations excludeEventId={id} category="voyage" />

 {/* ══ TOAST ══ */}
 {vToast && (
   <div style={{
     position: 'fixed', bottom: '24px', left: '24px', zIndex: 999999,
     borderRadius: '10px', padding: '10px 16px', minWidth: '220px', maxWidth: '340px',
     background: vToast.type === 'warning' ? '#fffbeb' : vToast.type === 'success' ? '#f0fdf4' : '#fef2f2',
     border: `1.5px solid ${vToast.type === 'warning' ? '#fbbf24' : vToast.type === 'success' ? '#4ade80' : '#fca5a5'}`,
     color: vToast.type === 'warning' ? '#92400e' : vToast.type === 'success' ? '#166534' : '#991b1b',
     fontSize: '0.85rem', fontWeight: '600', boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
     animation: 'vSlideIn 0.25s ease-out',
   }}>
     <style>{`@keyframes vSlideIn { from { transform: translateX(-60px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }`}</style>
     <i className={`fa ${vToast.type === 'warning' ? 'fa-exclamation-triangle' : vToast.type === 'success' ? 'fa-check-circle' : 'fa-times-circle'} me-2`}/>
     {vToast.msg}
   </div>
 )}

 {/* ══ RESERVATION STEPPER MODAL ══ */}
 {showResModal && createPortal(
   <>
     <style>{`
       @keyframes resVoyageIn { from { opacity:0; transform:scale(0.92) translateY(20px); } to { opacity:1; transform:scale(1) translateY(0); } }
       @keyframes checkVoyagePop { 0%{transform:scale(0)} 60%{transform:scale(1.3)} 100%{transform:scale(1)} }
     `}</style>
     {/* Backdrop */}
     <div onClick={closeResModal} style={{ position: 'fixed', inset: 0, background: 'rgba(1,10,30,0.6)', backdropFilter: 'blur(5px)', zIndex: 200000 }} />
     {/* Panel */}
     <div style={{ position: 'fixed', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 200001, padding: '16px' }}>
       <div onClick={e => e.stopPropagation()} style={{
         background: 'white', borderRadius: '22px', width: '100%', maxWidth: '560px',
         maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 32px 80px rgba(1,34,92,0.22)',
         animation: 'resVoyageIn 0.28s cubic-bezier(0.34,1.4,0.64,1)',
       }}>
         {/* Header */}
         <div style={{ padding: '24px 28px 0', borderBottom: '1px solid #f1f5f9' }}>
           <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
             <span style={{ fontSize: '1.1rem', fontWeight: '700', color: '#01225C' }}>
               {resStep === 3 ? 'Réservation confirmée !' : 'Réserver votre voyage'}
             </span>
             <button onClick={closeResModal} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.2rem', color: '#94a3b8', padding: '4px', lineHeight: 1 }}>
               <i className="fa fa-times" />
             </button>
           </div>
           {/* Step indicators */}
           <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '24px' }}>
             {[1, 2, 3].map(s => (
               <React.Fragment key={s}>
                 <div style={{
                   width: '28px', height: '28px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                   fontSize: '0.75rem', fontWeight: '700', flexShrink: 0,
                   background: s < resStep ? '#01225C' : s === resStep ? '#01225C' : '#f1f5f9',
                   color: s <= resStep ? 'white' : '#94a3b8',
                   transition: 'all 0.2s',
                 }}>
                   {s < resStep ? <i className="fa fa-check" style={{ fontSize: '0.65rem' }} /> : s}
                 </div>
                 {s < 3 && <div style={{ flex: 1, height: '2px', background: s < resStep ? '#01225C' : '#f1f5f9', transition: 'background 0.3s' }} />}
               </React.Fragment>
             ))}
           </div>
         </div>

         {/* Body */}
         <div style={{ padding: '24px 28px' }}>

           {/* ── Step 1: Récapitulatif voyage ── */}
           {resStep === 1 && resVoyage && (() => {
             const fmt = (d) => { if (!d) return '-'; try { return new Date(d).toLocaleDateString('fr-FR', { day:'2-digit', month:'short', year:'numeric' }); } catch { return d; } };
             return (
               <div>
                 <div style={{ fontSize: '0.8rem', fontWeight: '700', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '14px' }}>
                   Votre sélection
                 </div>
                 <div style={{ background: 'linear-gradient(135deg,#01225C,#0a3d7a)', borderRadius: '16px', padding: '20px', color: 'white', marginBottom: '18px' }}>
                   <div style={{ fontSize: '1.05rem', fontWeight: '700', marginBottom: '4px' }}>{resVoyage.voyage_name || 'Voyage'}</div>
                   {resVoyage.voyage_destination && <div style={{ fontSize: '0.85rem', opacity: 0.8 }}><i className="fa fa-map-marker-alt me-1" />{resVoyage.voyage_destination}</div>}
                 </div>
                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '18px' }}>
                   {[
                     { icon: 'fa-plane-departure', label: 'Départ', value: fmt(resVoyage.voyage_departure_date) },
                     { icon: 'fa-plane-arrival', label: 'Retour', value: fmt(resVoyage.voyage_return_date) },
                     resVoyage.voyage_departure_city && { icon: 'fa-map-pin', label: 'Ville de départ', value: resVoyage.voyage_departure_city },
                     resVoyage.voyage_nights && { icon: 'fa-moon', label: 'Durée', value: `${resVoyage.voyage_nights} nuit${resVoyage.voyage_nights > 1 ? 's' : ''}` },
                   ].filter(Boolean).map((item, i) => (
                     <div key={i} style={{ background: '#f8fafc', borderRadius: '10px', padding: '12px 14px' }}>
                       <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginBottom: '2px' }}><i className={`fa ${item.icon} me-1`} />{item.label}</div>
                       <div style={{ fontSize: '0.9rem', fontWeight: '600', color: '#0f172a' }}>{item.value}</div>
                     </div>
                   ))}
                 </div>
                 {resVoyage.voyage_rooms && (
                   <div style={{ background: '#f8fafc', borderRadius: '10px', padding: '12px 14px', marginBottom: '12px' }}>
                     <div style={{ fontSize: '0.72rem', color: '#94a3b8', marginBottom: '6px' }}><i className="fa fa-bed me-1" />Chambres</div>
                     {resVoyage.voyage_rooms.split('\n').map((r, i) => (
                       <div key={i} style={{ fontSize: '0.85rem', color: '#374151', marginBottom: '2px' }}>{r}</div>
                     ))}
                   </div>
                 )}
                 <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#eff6ff', borderRadius: '10px', padding: '14px 16px' }}>
                   <span style={{ fontSize: '0.9rem', color: '#01225C', fontWeight: '600' }}>Total à payer</span>
                   <span style={{ fontSize: '1.2rem', fontWeight: '800', color: '#01225C' }}>{Number(resVoyage.voyage_total_price || 0).toLocaleString()} TND</span>
                 </div>
               </div>
             );
           })()}

           {/* ── Step 2: Coordonnées ── */}
           {resStep === 2 && (() => {
             const fi = (key) => ({
               ...resInputCss,
               borderColor: resFieldErrors[key] ? '#ef4444' : '#e2e8f0',
               boxShadow: resFieldErrors[key] ? '0 0 0 3px rgba(239,68,68,0.12)' : 'none',
             });
             const clearErr = (key) => {
               if (resFieldErrors[key]) setResFieldErrors(prev => { const n = { ...prev }; delete n[key]; return n; });
             };
             const ErrMsg = ({ field }) => resFieldErrors[field]
               ? <div style={{ color: '#ef4444', fontSize: '0.72rem', marginTop: '4px' }}><i className="fa fa-exclamation-circle me-1" />{resFieldErrors[field]}</div>
               : null;
             return (
               <div>
                 <div style={{ fontSize: '0.8rem', fontWeight: '700', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '16px' }}>
                   Vos coordonnées
                 </div>
                 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                   <div style={{ gridColumn: '1/-1' }}>
                     <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#64748b', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Nom et Prénom *</div>
                     <input value={resForm.nom_prenom} onChange={e => { setResForm(p => ({ ...p, nom_prenom: e.target.value })); clearErr('nom_prenom'); }} onFocus={onFocusRes} onBlur={onBlurRes} placeholder="Nom et prénom complet" style={fi('nom_prenom')} />
                     <ErrMsg field="nom_prenom" />
                   </div>
                   <div>
                     <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#64748b', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Email *</div>
                     <input type="email" value={resForm.email} onChange={e => { setResForm(p => ({ ...p, email: e.target.value })); clearErr('email'); }} onFocus={onFocusRes} onBlur={onBlurRes} placeholder="votre@email.com" style={fi('email')} />
                     <ErrMsg field="email" />
                   </div>
                   <div>
                     <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#64748b', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Téléphone *</div>
                     <input value={resForm.telephone} onChange={e => { setResForm(p => ({ ...p, telephone: e.target.value })); clearErr('telephone'); }} onFocus={onFocusRes} onBlur={onBlurRes} placeholder="+216 XX XXX XXX" style={fi('telephone')} />
                     <ErrMsg field="telephone" />
                   </div>
                   <div>
                     <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#64748b', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>WhatsApp</div>
                     <input value={resForm.whatsapp} onChange={e => setResForm(p => ({ ...p, whatsapp: e.target.value }))} onFocus={onFocusRes} onBlur={onBlurRes} placeholder="+216 XX XXX XXX" style={resInputCss} />
                   </div>
                   <div>
                     <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#64748b', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Adresse</div>
                     <input value={resForm.adresse} onChange={e => setResForm(p => ({ ...p, adresse: e.target.value }))} onFocus={onFocusRes} onBlur={onBlurRes} placeholder="Rue, numéro..." style={resInputCss} />
                   </div>
                   <div>
                     <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#64748b', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Ville</div>
                     <input value={resForm.ville} onChange={e => setResForm(p => ({ ...p, ville: e.target.value }))} onFocus={onFocusRes} onBlur={onBlurRes} placeholder="Votre ville" style={resInputCss} />
                   </div>
                   <div style={{ gridColumn: '1/-1' }}>
                     <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#64748b', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Mode de paiement</div>
                     <select value={resForm.mode_paiement} onChange={e => setResForm(p => ({ ...p, mode_paiement: e.target.value }))} style={{ ...resInputCss, cursor: 'pointer' }}>
                       <option value="">Sélectionnez...</option>
                       <option value="Virement bancaire">Virement bancaire</option>
                       <option value="Espèces">Espèces</option>
                       <option value="Chèque">Chèque</option>
                       <option value="Carte bancaire">Carte bancaire</option>
                     </select>
                   </div>
                   <div style={{ gridColumn: '1/-1' }}>
                     <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#64748b', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Remarque</div>
                     <textarea value={resForm.remarque} onChange={e => setResForm(p => ({ ...p, remarque: e.target.value }))} onFocus={onFocusRes} onBlur={onBlurRes} placeholder="Demandes spéciales, informations complémentaires..." rows={3} style={{ ...resInputCss, resize: 'none' }} />
                   </div>
                 </div>
               </div>
             );
           })()}

           {/* ── Step 3: Confirmation ── */}
           {resStep === 3 && (
             <div style={{ textAlign: 'center', padding: '20px 0' }}>
               <div style={{ width: '72px', height: '72px', borderRadius: '50%', background: 'linear-gradient(135deg,#01225C,#0a3d7a)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', animation: 'checkVoyagePop 0.4s cubic-bezier(0.34,1.4,0.64,1)' }}>
                 <i className="fa fa-check" style={{ color: 'white', fontSize: '1.6rem' }} />
               </div>
               <div style={{ fontSize: '1.15rem', fontWeight: '700', color: '#01225C', marginBottom: '10px' }}>Demande envoyée !</div>
               <div style={{ fontSize: '0.9rem', color: '#64748b', lineHeight: '1.6' }}>
                 Votre demande de réservation pour <strong>{resVoyage?.voyage_name}</strong> a été reçue.<br />
                 Notre équipe vous contactera dans les plus brefs délais.
               </div>
             </div>
           )}
         </div>

         {/* Footer */}
         <div style={{ padding: '0 28px 24px', display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
           {resStep < 3 ? (
             <>
               <button onClick={resStep === 1 ? closeResModal : () => setResStep(1)} style={{ flex: 1, padding: '11px 0', borderRadius: '10px', border: '1.5px solid #e2e8f0', background: 'white', color: '#64748b', fontWeight: '600', fontSize: '0.9rem', cursor: 'pointer' }}>
                 {resStep === 1 ? 'Annuler' : 'Retour'}
               </button>
               <button
                 onClick={resStep === 1 ? () => setResStep(2) : submitReservation}
                 disabled={resSending}
                 style={{ flex: 2, padding: '11px 0', borderRadius: '10px', border: 'none', background: 'linear-gradient(135deg,#01225C,#0a3d7a)', color: 'white', fontWeight: '700', fontSize: '0.9rem', cursor: resSending ? 'not-allowed' : 'pointer', opacity: resSending ? 0.7 : 1 }}
               >
                 {resSending ? <><i className="fa fa-spinner fa-spin me-2" />Envoi...</> : resStep === 1 ? <>Continuer <i className="fa fa-arrow-right ms-1" /></> : <>Envoyer la réservation <i className="fa fa-paper-plane ms-1" /></>}
               </button>
             </>
           ) : (
             <button onClick={closeResModal} style={{ flex: 1, padding: '11px 0', borderRadius: '10px', border: 'none', background: 'linear-gradient(135deg,#01225C,#0a3d7a)', color: 'white', fontWeight: '700', fontSize: '0.9rem', cursor: 'pointer' }}>
               Fermer
             </button>
           )}
         </div>
       </div>
     </div>
   </>,
   document.body
 )}

 </>
 );
}

export default VoyageDetails;